import { useContext } from 'react';
import { SchedulesContext } from '../SchedulesContext';

export const useSchedulesContext = () => useContext(SchedulesContext);
